module.exports = "/build/web/svg/login.601e6b739a9efb501776ea73a845a160.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/login.svg
// module id = 170
// module chunks = 24